/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { UserSignInRequest } from '../models/user-sign-in.request';
import { UserConfirmAccountRequest } from '../models/user-confirm-account.request';
import { User } from '../models/user.entity';
import { UserNormalLoginRequest } from '../models/user-normal-login.request';
import { UserAnonymousLoginRequest } from '../models/user-anonymous-login.request';
import { UserResetPswStepOneRequest } from '../models/user-reset-psw-step-one.request';
import { UserResetPswStepTwoRequest } from '../models/user-reset-psw-step-two.request';
import { UserResetPswStepThreeRequest } from '../models/user-reset-psw-step-three.request';
import { GamePrivateLoginRequest } from '../models/game-private-login.request';
import { GamePublicLoginRequest } from '../models/game-public-login.request';
import { PlayerLoginRequest } from '../models/player-login.request';
import { PlayerLogoutRequest } from '../models/player-logout.request';
import { TokenRefreshRequest } from '../models/token-refresh.request';

@Injectable()
export class AuthService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public getKey(): Observable<string> {
		return this.http.get(`${this.config.apiUrl}/api/v2/public/auth/key`, {
			responseType: 'text',
		});
	}

	public register(
		body: UserSignInRequest | UserConfirmAccountRequest,
	): Observable<User> {
		return this.http.post<User>(
			`${this.config.apiUrl}/api/v3/public/auth/sign-in`,
			body,
		);
	}

	public userLoginV3(
		body: UserNormalLoginRequest | UserAnonymousLoginRequest,
	): Observable<string> {
		return this.http.post(
			`${this.config.apiUrl}/api/v3/public/auth/user-login`,
			body,
			{ responseType: 'text' },
		);
	}

	public userResetPassword(
		body:
			| UserResetPswStepOneRequest
			| UserResetPswStepTwoRequest
			| UserResetPswStepThreeRequest,
	): Observable<void | boolean | User> {
		return this.http.post<void | boolean | User>(
			`${this.config.apiUrl}/api/v2/public/auth/user-reset-password`,
			body,
		);
	}

	public gameLoginV3(
		body: GamePrivateLoginRequest | GamePublicLoginRequest,
	): Observable<string> {
		return this.http.post(
			`${this.config.apiUrl}/api/v3/public/auth/game-login`,
			body,
			{ responseType: 'text' },
		);
	}

	/**
	 * @deprecated use playerLoginV3 instead
	 */
	public playerLogin(body: PlayerLoginRequest): Observable<string> {
		return this.http.post(
			`${this.config.apiUrl}/api/v2/public/auth/player-login`,
			body,
			{ responseType: 'text' },
		);
	}

	public playerLoginV3(body: PlayerLoginRequest): Observable<string> {
		return this.http.post(
			`${this.config.apiUrl}/api/v3/public/auth/player-login`,
			body,
			{ responseType: 'text' },
		);
	}

	public playerLogoutV3(body: PlayerLogoutRequest): Observable<void> {
		return this.http.post<void>(
			`${this.config.apiUrl}/api/v3/public/auth/player-logout`,
			body,
		);
	}

	public refreshTokens(
		body: TokenRefreshRequest[],
	): Observable<TokenRefreshRequest[]> {
		return this.http.post<TokenRefreshRequest[]>(
			`${this.config.apiUrl}/api/v2/public/auth/token-refresh`,
			body,
		);
	}
}
